import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ICustomDeadlineSplit } from '@settings/models/index';

@Injectable({
  providedIn: 'root'
})
export class CustomDeadlineDOS {
  private _selectedMonthSubject = new BehaviorSubject<Date>(new Date());
  readonly selectedMonth$ = this._selectedMonthSubject.asObservable();

  private _customDeadlineSubject: BehaviorSubject<ICustomDeadlineSplit> = new BehaviorSubject(null);
  readonly customDeadlineData$ = this._customDeadlineSubject.asObservable();

  private _customDataModifiedSubject: BehaviorSubject<ICustomDeadlineSplit> = new BehaviorSubject(null);
  readonly customDataModified$ = this._customDataModifiedSubject.asObservable();

  private _unsavedCustomDeadlineSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  readonly unsavedCustomDeadline$ = this._unsavedCustomDeadlineSubject.asObservable();

  updateCustomDeadlineData(deadlineData: ICustomDeadlineSplit): void {
    this._customDeadlineSubject.next(deadlineData);
  }

  updateSelectedMonth(newSelectedMonth: Date): void {
    this._selectedMonthSubject.next(newSelectedMonth);
  }

  getSelectedMonthSnapshot(): Date {
    return this._selectedMonthSubject.value;
  }

  updateCustomDataModified(newData: ICustomDeadlineSplit): void {
    this._customDataModifiedSubject.next(newData);
  }

  getCustomDataModifiedSnapshot(): ICustomDeadlineSplit {
    return this._customDataModifiedSubject.value;
  }

  updateUnsavedCustomDeadline(modified: boolean): void {
    this._unsavedCustomDeadlineSubject.next(modified);
  }

  getUnsavedCustomDeadlineSnapshot(): boolean {
    return this._unsavedCustomDeadlineSubject.value;
  }
}
